import { dequal as deepEqual } from 'dequal/lite';
import type { ConfigOverride } from '#dn-types/host.ts';
import type { OverrideMap } from '../hooks/useOverrideMaps.ts';

/**
 * Filters out config overrides that are equal to their tag default values,
 * as long as they were not also host overrides to start with.
 *
 * @param configOverrides Current overrides from the form
 * @param overrideMap A Map of config keys and values that come from tags
 * @param hostOverrides Any overrides that were set on the host before it was edited
 */
export function filterTagProvidedOverrides(
  configOverrides: ConfigOverride[],
  overrideMap: OverrideMap,
  hostOverrides: ConfigOverride[]
) {
  return configOverrides.filter(({ key, value }) => {
    // Don't filter out an override if it was previously set explicitly on the host.
    if (hostOverrides.find((o) => o.key === key && deepEqual(o.value, value))) return true;

    const overrideFromTag = overrideMap.get(key);
    return overrideFromTag?.source !== 'host' && !deepEqual(value, overrideFromTag?.value.value);
  });
}
